export default __webpack_public_path__ + "static/media/IMG_5530.401b3faf.jpg";